// https://github.com/reactjs/redux/issues/99
export default function(state = {}, action) {
  const typeMap = {
    AUTHOR_PAGE_LOADING() {
      return {
        isLoading: true,
        authorPage: action.authorPage
      };
    },
    AUTHOR_PAGE_LOADED() {
      return {
        isLoading: false,
        data: action.authorPage
      };
    },
    AUTHOR_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.authorPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
